import { render, staticRenderFns } from "./physique-result.vue?vue&type=template&id=120ee80e&scoped=true"
import script from "./physique-result.vue?vue&type=script&lang=js"
export * from "./physique-result.vue?vue&type=script&lang=js"
import style0 from "./physique-result.vue?vue&type=style&index=0&id=120ee80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120ee80e",
  null
  
)

export default component.exports